export default "__VITE_ASSET__BqEn7dct__"